const wristFlexorMassStretch = {
  name: 'Wrist flexor mass stretch',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/flexor+mass+stretch.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/flexor+mass+stretch.gif',
  text: 'Lift your arm up to shoulder height, then with your opposite hand, press your palm backwards until you feel a gentle stretch in your wrist. Hold this position. This stretch addresses the forearm/wrist flexors: flexor carpi radialis, flexor carpi ulnaris, flexor digitorum profundus, flexor digitorum superficialis.',
};

const wristExtensorMassStretch = {
  name: 'Wrist extensor mass stretch',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/extensor+mass+stretch.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/extensor+mass+stretch.gif',
  text: 'Begin in a standing upright position with one arm in front of your body, palm facing the floor. With your other hand, bend your wrist downward until you feel a stretch. This stretch addressed the forearm/wrist extensors: extensor digitorum, extensor indicis, extensor carpi radialis longus, extensor carpi radialis brevis, extensor carpi ulnaris.',
};

const singleFingerFlexionStretch = {
  name: 'Single finger flexion stretch',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/single+flinger+flexor+stretch.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/single+flinger+flexor+stretch.gif',
  text: 'Lift your arm to shoulder height, elbow straight. Curl your wrist up and individually curl each finger toward your palm and wrist. This is an excellent stretch to individualize the muscles and tendons of the extensor digiti minimi.',
};

const singleFingerExtensionStretch = {
  name: 'Single Finger extension stretch',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/single+finger+extension+stretch.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/single+finger+extension+stretch.gif',
  text: 'Place your hand flat on the table. Individually lift each finger up and hold. This stretch will individually stretch the muscles and tendons of the flexor digitorum profundus and superficialis, muscles that flex/curl your fingers.',
};

const lumbricalStretch = {
  name: 'Lumbrical stretch',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/lumbrical+stretch.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/lumbrical+stretch.gif',
  text: 'Curl your finger tips to the base of each finger. With your opposite hand grip and extend your fingers until you feel a stretch through the palm of your hand. The lumbrical muscles flex/bend your metacarpophalangeal joints (knuckles) while also extend the interphalangeal joints which are the joints between the individual bones of each finger. Hold this stretch for 20-30 seconds on each hand. These muscles get tight following prolonged gripping of a controller.',
};

const standingFlexorMassStretch = {
  name: 'Standing flexor mass stretch',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/standing+flexor+mass+stretch.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/standing+flexor+mass+stretch.gif',
  text: 'Stand and place the palm of hands flat on the table, fingers facing your body. Maintain full contact of the fingers and palm. Lean backward until you feel a stretch in your forearm. This is an excellent stretch to address the flexor mass muscle group. This can be done multiple times throughout play to release tightness in the forearms.',
};

const standingExtensorMassStretch = {
  name: 'Standing extensor mass stretch',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/Standing+extensor+mass+stretch.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/Standing+extensor+mass+stretch.gif',
  text: 'Stand and place the back of hands on the table, fingers facing your body. Maintain full contact of the dorsum (back) of the hand on the table and lean back until you feel a stretch in the top of the forearm. This is an global stretch to address the extensor mass muscle group; extensor digitorum, extensor indicis, extensor carpi radialis longus, extensor carpi radialis brevis, extensor carpi ulnaris.',
};

const indexFingerStretch = {
  name: 'Index finger stretch',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/index+finger+isolated+stretch.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/index+finger+isolated+stretch.gif',
  text: 'Grip and curl the tip of your index finger down toward the base. Extend your index finger at the base of the finger. This stretch will specifically stretch the flexor indicis.',
};

const pinkyFingerStretch = {
  name: 'Pinky finger stretch',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/pinky+flexor+stretch.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/pinky+flexor+stretch.gif',
  text: 'Grip and curl the tip of your pinky finger down toward the base. Extend your pinky at the base of the finger. This stretch will specifically stretch the flexor digiti minimi.',
};

const prayerStretch = {
  name: 'Prayer stretch',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/Prayer+stretch.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/Prayer+stretch.gif',
  text: 'Place your hands together, fingers straight and pointed to the sky. Press your hands together and slide your thumb down the front of your chest while maintaining full contact of fingers and palms. This is an excellent stretch to address the flexor mass muscle group.',
};

const reversePrayerStretch = {
  name: 'Reverse Prayer stretch',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/reverse+prayer+stretch.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/reverse+prayer+stretch.gif',
  text: 'Place both hands together so the back of each hand is contacting the other. Fingers pointed toward the floor. Push hands together and lift towards the sky. This is an global stretch to address the extensor mass muscle group; extensor digitorum, extensor indicis, extensor carpi radialis longus, extensor carpi radialis brevis, extensor carpi ulnaris.',
};

const thumbOpposition = {
  name: 'Thumb opposition',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/thumb+opposition.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/thumb+opposition.gif',
  text: 'Touch the tip of your thumb together with one finger, then separate them and repeat with each of your other fingers. This exercises strengthens the opponens pollicis and opponens digiti minimi. These muscles control your ability to draw your finger thumb and picky finger tips to the middle of your hand along with the palmar interosseous muscles.',
};

const thumbWindshieldWipers = {
  name: 'Thumb windshield wipers',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/thumb+windshield+wipers.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/thumb+windshield+wipers.gif',
  text: 'Place your hand flat on the table, palm down. Move your thumb away and toward your hand like a windshield wiper. This exercise strengthens your abductor pollicis longus and brevis as well as adductor pollicis. Abduction means move away from the midline of the body and adductor means bring toward the midline of the body.',
};

const fingerSpreads = {
  name: 'Finger spreads',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/finger+spreads.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/finger+spreads.gif',
  text: 'Begin with your palms down. Spread your fingers apart.',
};

const tableTopUprights = {
  name: 'Table top uprights',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/uprights.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/uprights.gif',
  text: 'Start with your palm flat on the table keep your fingers straight and flex your knuckles to make a pincher grip with your hand.',
};

const soloFingerCurls = {
  name: 'Solo finger curls',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/solo+finger+curls.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/solo+finger+curls.gif',
  text: 'Place your hand palm down on the table with your fingertips hanging off the edge of the table. Flex (curl the tips of your fingers down and try to touch the edge of the table with your finger pads. This exercise isolates the flexor digitorum profundus.',
};

const fingerClaws = {
  name: 'Finger claws',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/finger+claws.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/finger+claws.gif',
  text: 'Start with you palm up and fingers straight. Curl your fingers in to mimic a claw hand.',
};

const isolatedFingertipLiftsWithBlock = {
  name: 'Isolated fingertip lifts with block',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/isolated+finger+extension.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/isolated+finger+extension.gif',
  text: 'Use a pencil or small tube an block all fingers except the finger of focus. Interlace this block to prevent extension of all other fingers while focusing on flexing 1 at a time. This exercise will improve neuromuscular control and strength of the individual finger extensors.',
};

const thumbToPinky = {
  name: 'Thumb to pinky',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/thumb+to+pinky.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/thumb+to+pinky.gif',
  text: 'Begin with your hand spread wide. Curl your thumb toward your pinky finger. Try and keep your hand flat throughout the repetitions. This exercise strengthens the opponens pollicis, flexor pollicis brevis and flexor pollicis longus. These 3 muscles flex (curl) your thumb and bring it across your palm.',
};

const thumbsUp = {
  name: 'Thumbs up',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/thumbs+up.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/thumbs+up.gif',
  text: 'Make a fist with your thumb lying across your fingers. Raise your thumb into a “thumbs up” position without moving fingers. This exercise strengthens the extensor pollicis longus and extensor pollicis brevis. These two muscles control the thumb and create the “thumbs up” position.',
};

const thumbTipToTip = {
  name: 'Thumb tip to tip',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/thumb+tip+to+tip.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/thumb+tip+to+tip.gif',
  text: 'Touch each fingertip individually with thumb. This will improve the strength and dexterity of the thumb.',
};

const fingerCurls = {
  name: 'Finger curls',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/finger+curls.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/finger+curls.gif',
  text: 'Curl your fingers toward the palmer side of your knuckles. This will help strengthen your finger flexors. Excellent exercise to increase your strength to pull the triggers on your controller.',
};

const soloFingerExtension = {
  name: 'Solo finger extension',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/solo+finger+extension.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/solo+finger+extension.gif',
  text: 'Place your hand palm down on the table. Extend (lift) the tips of your fingers down and try to lift as high as possible. This exercise isolates the extensor digitorum and extensor indicis.',
};

const openHandWristExtension = {
  name: 'open hand wrist extension',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/open+hand+wrist+extension.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/open+hand+wrist+extension.gif',
  text: 'Place an open hand palm down on the table. With your fingers out straight, extension your wrist by lifting your hand off the table while maintaining contact of the table with your arm. This exercise will specifically strengthen the extensors of the fingers and wrist. These extensors include: extensor pollicis longus, extensor digitorum, extensor indicis, extensor carpi radialis longus, extensor carpi radialis brevis, extensor carpi ulnaris.',
};

const wristWindshieldWipers = {
  name: 'Wrist windshield wipers',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/wrist+windsheild+wipers.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/wrist+windsheild+wipers.gif',
  text: 'Place your arms and hands palm down on the table. With your hands flat and fingers together, deviate your wrist left and right to mimic a windshield wiper. This exercise will strength the radial and ulnar deviators of the hand. The radial deviators include: flexor carpi radialis, extensor carpi radialis longus and extensor carpi radialis brevis. The ulnar deviators includes: the flexor carpi ulnaris and extensor carpi ulnaris.',
};

const wristFlips = {
  name: 'Wrist flips',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/wrist+flips.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/wrist+flips.gif',
  text: 'With your elbows bent at your side. Rapidly flip your palms up and down. This exercise will strengthen the wrist pronators and supinator.',
};

const thumbClaws = {
  name: 'Thumb claws',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/thumb+claws.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/thumb+claws.gif',
  text: 'Curl the tip of your thumb to the base of the thumb/palm. This exercise specifically strengthens the flexor pollicis brevis and longus. These muscles flex (curl) the thumb.',
};

const forearmWindshieldWipers = {
  name: 'Forearm winshield wipers',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/Arm+windshield+wiper.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/Arm+windshield+wiper.gif',
  text: 'Arms out straight. Palms out facing away, fingers pointed towards the floor. Pronate/supinate (turn up and down) your wrists to mimic a bottom windshield wiper. This exercise strengthen wrist pronation and supination. Pronators include: Pronator quadratus, Pronator teres. Supinators include: biceps, supinator.',
};

const thumbToFingerBase = {
  name: 'Thumb to finger base',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/thumb+to+finger+base.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/thumb+to+finger+base.gif',
  text: 'Begin with palm up. Curl your thumb to the base of each individual finger. This will improve the strength and dexterity of the thumb.',
};

const rocketfellers = {
  name: 'Rocketfellers',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/rockefellers.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/rockefellers.gif',
  text: 'Place your hands on the table in the upright position. Individually extend each finger out kicking like a Rockefeller. This will improve the strength of the extensor digitorum and extensor indicis as well as the dexterity and neuromuscular control of each individual finger.',
};

const closedHandWristExtension = {
  name: 'Closed hand wrist extension',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/closed+wrist+flexion+extension.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/closed+wrist+flexion+extension.gif',
  text: 'Make a fist with your hand and extend your wrist. This exercise strengths your wrist extensors. These extensors include: extensor digitorum, extensor indicis, extensor carpi radialis longus, extensor carpi radialis brevis, extensor carpi ulnaris. You can complete this exercise with your elbow flexed and extended to isolate the one and two joint muscles.',
};

const openHandWristFlexion = {
  name: 'Open hand wrist flexion',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/open+hand+wrist+flexion.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/open+hand+wrist+flexion.gif',
  text: 'Place your hand palm up on the table. While keeping your arm flat on the table, curl your wrist up while maintaining an open hand. The flexors include: flexor carpi radialis, flexor carpi ulnaris, flexor digitorum profundus, flexor digitorum superficialis.',
};

const isolatedFingertipCurlsWithBlock = {
  name: 'Isolated fingertip curls with block',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/isolated+finger+tip+curl+with+blok.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/isolated+finger+tip+curl+with+blok.gif',
  text: 'Use a pencil or small tube an block all fingers except the finger of focus. Interlace this block to prevent flexion of all other fingers while focusing on flexing 1 at a time. This exercise will improve neuromuscular control and strength of the individual finger flexors.',
};

const dynamicWristFlexionAndExtension = {
  name: 'Dynamic wrist flexion and extension',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/d+wrist+flex+ext+fingers+spread.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/d+wrist+flex+ext+fingers+spread.gif',
  text: 'Reach your arms out in front. Make a fist. Rapidly flex and extend your wrist to activate/warm-up your flexor and extensor mass.',
};

const rapidFingerSpreadsInWristFlexion = {
  name: 'Rapid Finger spreads in wrist flexion',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/rapid+fingers+spreads+wrist+flexion.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/rapid+fingers+spreads+wrist+flexion.gif',
  text: 'Reach your arms out in front. With your palms down, flex your wrist so your fingers are facing the floor. Rapidly spread your fingers out wide and back together. This will warm-up your lumbrical muscles which control abduction and adduction of your fingers while also mobilizing the tendons of your extensor mass',
};

const rapidFingerSpreadsInWristExtension = {
  name: 'Rapid Finger spreads in wrist extension',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/Rapid+fingers+spreads+wrist+extension.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/Rapid+fingers+spreads+wrist+extension.gif',
  text: 'Reach your arms out in front. With your palms down, extend your wrist so your fingers are facing the ceiling. Rapidly spread your fingers out wide and back together. This will warm-up your lumbrical muscles which control abduction and adduction of your fingers while also mobilizing your flexor mass.',
};

const openHandCircles = {
  name: 'Open hand circles',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/open+hand+wrist+circles.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/open+hand+wrist+circles.gif',
  text: 'Keep your hand open and fingers spread. Make 10 circles each way with your wrist while maintaining your fingers spread. This will warm-up your wrist to have the ability to move in all planes of motion.',
};

const closedHandCircles = {
  name: 'Closed hand circles',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/closed+hand+circles.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/closed+hand+circles.gif',
  text: 'Make a fist, roll your wrist to the left and then to the right. This will warm-up your wrist to have the ability to move in all planes of motion.',
};

const snuffBoxSelfMassage = {
  name: 'Snuff box self massage',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/snuff+box+massage.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/snuff+box+massage.gif',
  text: 'Hold one hand out in front of you. With the other hand, use a tip grip and perform a circular massage along the muscles between your thumb and 1st digit. The snuff box house some of the largest muscles in the hand also known as the thenar muscle group. These include: opponens pollicis, adductor pollicis brevis and flexor pollicis brevis.',
};

const outstretchedFingersWristFlexionAndExtension = {
  name: 'Outstretched fingers wrist flexion and extension',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/outstretch+fingers+wrist+flex+ext.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/outstretch+fingers+wrist+flex+ext.gif',
  text: 'Arms extended out at shoulder level. Spread your fingers out as much as possible. Flex and extension wrist by pointing your fingers up towards the ceiling and down towards the floor. This is a mobility technique to loosen up your flexor and extensor muscle/tendon group.',
};

const fingerPulls = {
  name: 'Finger pulls',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/finger+pulls.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/finger+pulls.gif',
  text: 'Stand and place your palm/hand flat on the table. Individually lift each finger from the table. This is an excellent stretch individualize the muscles and tendons of the extensor digiti minimi.',
};

const shakeItOut = {
  name: 'Shake it out',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/shake+it+out.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/shake+it+out.gif',
  text: 'Relax your fingers. Shake your fingers out as if you were trying to air dry your hands. This is an excellent method to increase blood flow to the hands/fingers.',
};

const palmFlips = {
  name: 'Palm flips',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/palm+flips.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/palm+flips.gif',
  text: 'Elbows at your side flexed at 90 degrees. With your fingers spread as wide, rapidly turn your hands palm up and palm down. Be sure to utilize your full range of motion. This is a warm-up for the pronators and supinators.',
};

const knuckleSelfMassage = {
  name: 'knuckle self massage',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/knuckle+self+massage.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/knuckle+self+massage.gif',
  text: 'Hold one hand out in front of you. With the other hand, use a tip grip and perform a circular massage on top if each individual muscle. This will help mobilize the A1 pulley of the flexor digitorum profundus and superficialis. This is a common site of trigger finger.',
};

const watchWinders = {
  name: 'Watch winders',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/watch+winders.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/watch+winders.gif',
  text: 'Place your hands in the prayer position. Press your palms and fingers into each other. Rotate your wrists back and forth to point your fingers towards and away from your body. This is an mobilization technique to mobilize your flexor mass muscle group in all ranges of pronation and supination.',
};

const finkelsteinStretch = {
  name: 'Finkelstein stretch',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/finkelstein+stretch.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/finkelstein+stretch.gif',
  text: 'Begin in a standing upright position. Straighten your elbow, and position your wrist so that you are in a thumbs-up position with your thumb tucked into your palm under your other fingers. Slowly bend your wrist, moving your fingers toward the floor. Return to the starting position. This dynamic warm-up actively stretches the abductor pollicis longus and brevis as well as extensor pollicis longus and extensor pollicis brevis.',
};

const lacedHandSqueeze = {
  name: 'Laced hand squeeze',
  video: 'https://apmtrainingvideos.s3.amazonaws.com/laced+hand+squeeze.mp4',
  gif: 'https://apmtrainingvideos.s3.amazonaws.com/laced+hand+squeeze.gif',
  text: 'Interlace your fingers as if you are holding your own hand. Squeeze your fingers together. This will help mobilize all tendons in the fingers to improve glide through the pulleys of your fingers.',
};

const Exercises = {
  wristFlexorMassStretch,
  wristExtensorMassStretch,
  singleFingerExtensionStretch,
  singleFingerFlexionStretch,
  lumbricalStretch,
  standingExtensorMassStretch,
  standingFlexorMassStretch,
  indexFingerStretch,
  pinkyFingerStretch,
  prayerStretch,
  reversePrayerStretch,
  thumbOpposition,
  thumbWindshieldWipers,
  fingerSpreads,
  tableTopUprights,
  soloFingerCurls,
  fingerClaws,
  isolatedFingertipCurlsWithBlock,
  isolatedFingertipLiftsWithBlock,
  thumbToPinky,
  thumbsUp,
  thumbTipToTip,
  fingerCurls,
  soloFingerExtension,
  openHandCircles,
  openHandWristExtension,
  openHandWristFlexion,
  wristWindshieldWipers,
  wristFlips,
  thumbClaws,
  knuckleSelfMassage,
  lacedHandSqueeze,
  finkelsteinStretch,
  watchWinders,
  forearmWindshieldWipers,
  dynamicWristFlexionAndExtension,
  thumbToFingerBase,
  rocketfellers,
  closedHandWristExtension,
  palmFlips,
  shakeItOut,
  fingerPulls,
  outstretchedFingersWristFlexionAndExtension,
  snuffBoxSelfMassage,
  closedHandCircles,
  rapidFingerSpreadsInWristExtension,
  rapidFingerSpreadsInWristFlexion,
};

export default Exercises;
